import React from "react";
import { Icon } from "@iconify/react";
import style from "../scss/BotonIcono.module.scss";

// Botón cuadrado solo con ícono para las acciones de las tablas.
// etiqueta: texto del tooltip y del lector de pantalla (obligatorio: el botón no tiene texto visible)
// variante: "primario" | "peligro" | "exito" | "neutro"
const BotonIconoComponent = ({ icono, etiqueta, variante = "primario", onClick, deshabilitado = false }) => (
  <button
    type="button"
    className={`${style.boton} ${style[variante]}`}
    onClick={onClick}
    disabled={deshabilitado}
    title={etiqueta}
    aria-label={etiqueta}
  >
    <Icon icon={icono} aria-hidden="true" />
  </button>
);

// Acciones más usadas: mismo ícono y color en toda la app
export const BotonEditar = ({ etiqueta = "Editar", ...props }) => (
  <BotonIconoComponent icono="mdi:pencil-outline" etiqueta={etiqueta} variante="primario" {...props} />
);

export const BotonEliminar = ({ etiqueta = "Eliminar", ...props }) => (
  <BotonIconoComponent icono="mdi:trash-can-outline" etiqueta={etiqueta} variante="peligro" {...props} />
);

// Contenedor de los botones de una fila (en línea, alineados a la derecha)
export const AccionesTabla = ({ children }) => <div className={style.acciones}>{children}</div>;

export default BotonIconoComponent;
